module.exports = __webpack_public_path__ + "static/img/gzwm.5940217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzwm.png
// module id = KnYT
// module chunks = 15